import { CollectionMetaParser, JsonAPIDocument, JsonAPIProvider } from 'json-api-hooks';
import React, { FC, PropsWithChildren } from 'react';

import useFetchErrorHandler from '../../hooks/useFetchErrorHandler';
import useFetchSuccessHandler from '../../hooks/useFetchSuccessHandler';
import { getAuthenticityToken } from '../../lib/dom';
import { isNumber } from '../../lib/typeCheckers';

export const headers = ({
  accept,
  contentType,
}: {
  accept?: string;
  contentType?: string;
} = {}) => ({
  Accept: accept ?? 'application/vnd.api+json',
  'Content-Type': contentType ?? 'application/vnd.api+json',
  'X-CSRF-Token': getAuthenticityToken() ?? '',
});

const collectionMetaParser: CollectionMetaParser = (meta) => {
  const pageSize = meta['page-size'] ?? meta.pageSize;
  const totalCount = meta['total-count'] ?? meta.totalCount;

  return {
    pageSize: isNumber(pageSize) ? pageSize : 0,
    totalCount: isNumber(totalCount) ? totalCount : 0,
  };
};

const ApiProvider: FC<PropsWithChildren<{ seed: JsonAPIDocument[] }>> = ({ children, seed }) => {
  const fetchErrorHandler = useFetchErrorHandler();
  const fetchSuccessHandler = useFetchSuccessHandler();

  return (
    <JsonAPIProvider
      collectionMetaParser={collectionMetaParser}
      defaultRoot={GLOBALS.currentRoot}
      handleFetchError={fetchErrorHandler}
      handleSuccessError={fetchSuccessHandler}
      headers={headers}
      seed={seed}
    >
      {children}
    </JsonAPIProvider>
  );
};

export default ApiProvider;
